import React, { useContext } from "react";

import { observer } from "mobx-react";
import styled from "styled-components";

import ComponentContext from "../../../../contexts/ComponentContext";
import { useStores } from "../../../../contexts/StoreContext";
import useIsHydrated from "../../../hooks/useIsHydrated";
import useDevice from "../../../customHooks/useDevice";
import HoursFilter from "./HoursFilter";
import LocationFilter from "./LocationFilter";
import RolesFilter from "./RolesFilter";

const StyledContainer = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.isMobile ? "column" : "row")};
  gap: 1rem;
  padding: 1rem 0;
  justify-content: center;
  margin-bottom: 1rem;
`;

const StyledLink = styled.div`
  font-weight: 600;
  font-size: 0.8rem;
  text-decoration: underline;
  cursor: pointer;
  min-width: 100px;
  margin: auto;
`;

const FilterWrapper = styled.div`
  max-width: 400px;
  width: 100%;
`;

const ClearFilterWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: fit-content;
`;
function FilterBoxes() {
  const { isSmallScreen, isMobile } = useDevice();
  const isHydrated = useIsHydrated();
  const isServer = !isHydrated;
  const { additionalConfig, searchIconColour } = useContext(ComponentContext);

  const { filtersStore } = useStores();

  const { resetAllFilters } = filtersStore;

  return (
    <div>
      <StyledContainer isMobile={isMobile || isSmallScreen}>
        {additionalConfig?.filters?.role?.isHidden ? null : (
          <FilterWrapper>
            <RolesFilter
              isLoading={isServer}
              label={additionalConfig?.filters?.role?.label || "Role"}
              type="categories"
              className={additionalConfig?.filters?.dropdownClassName}
              borderRadius={additionalConfig?.filters?.borderRadius}
            />
          </FilterWrapper>
        )}
        {additionalConfig?.filters?.hours?.isHidden ? null : (
          <FilterWrapper>
            <HoursFilter
              isLoading={isServer}
              label={additionalConfig?.filters?.hours?.label || "Hours"}
              type="hours"
              className={additionalConfig?.filters?.dropdownClassName}
              borderRadius={additionalConfig?.filters?.borderRadius}
            />
          </FilterWrapper>
        )}
        {additionalConfig?.filters?.location?.isHidden ? null : (
          <FilterWrapper>
            <LocationFilter
              searchIconColour={searchIconColour}
              isLoading={isServer}
              label="Location"
              type="location"
              className={additionalConfig?.filters?.dropdownClassName}
              borderRadius={additionalConfig?.filters?.borderRadius}
            />
          </FilterWrapper>
        )}
        <ClearFilterWrapper>
          {isServer ? null : (
            <StyledLink
              onClick={() => resetAllFilters()}
              className={additionalConfig?.filters?.clearAllClassName}
            >
              Clear all
            </StyledLink>
          )}
        </ClearFilterWrapper>
      </StyledContainer>
    </div>
  );
}

export default observer(FilterBoxes);
